import type { Route } from "@route-types/+types/_index";
import { ResponseType } from "@sphtech/web2-core/ssr";
import heroEnDesktop from "../assets/landing/hero-en-desktop.jpg";
import LandingPage from "../pages/LandingPage";

const BASE_URL =
  import.meta.env.VITE_SITE_BASE_URL ?? "https://e-paper.sph.com.sg";

const TITLE = "SPH E-paper";
const DESCRIPTION =
  "Subscribe to SPH E-paper for full access to The Straits Times, Lianhe Zaobao, and more.";
const CANONICAL = `${BASE_URL}/`;
const ZH_URL = `${BASE_URL}/landing/zh`;
const OG_IMAGE = `${BASE_URL}${heroEnDesktop}`;

export function meta({}: Route.MetaArgs) {
  return [
    { title: TITLE },
    { name: "description", content: DESCRIPTION },
    { name: "robots", content: "index, follow" },
    { tagName: "link", rel: "canonical", href: CANONICAL },
    { property: "og:type", content: "website" },
    { property: "og:url", content: CANONICAL },
    { property: "og:title", content: TITLE },
    { property: "og:description", content: DESCRIPTION },
    { property: "og:image", content: OG_IMAGE },
    { property: "og:locale", content: "en_SG" },
    {
      tagName: "link",
      rel: "alternate",
      hrefLang: "en",
      href: CANONICAL,
    },
    {
      tagName: "link",
      rel: "alternate",
      hrefLang: "zh",
      href: ZH_URL,
    },
  ];
}

export function loader() {
  return {
    type: ResponseType.SUCCESS,
    statusCode: 200 as const,
    payload: {},
    lang: "en",
  };
}

export default function IndexRoute() {
  return <LandingPage lang="en" />;
}
